import { render, staticRenderFns } from "./canvasPanelPreview.vue?vue&type=template&id=8d4cce5a&scoped=true&"
import script from "./canvasPanelPreview.vue?vue&type=script&lang=js&"
export * from "./canvasPanelPreview.vue?vue&type=script&lang=js&"
import style0 from "./canvasPanelPreview.vue?vue&type=style&index=0&id=8d4cce5a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4cce5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d4cce5a')) {
      api.createRecord('8d4cce5a', component.options)
    } else {
      api.reload('8d4cce5a', component.options)
    }
    module.hot.accept("./canvasPanelPreview.vue?vue&type=template&id=8d4cce5a&scoped=true&", function () {
      api.rerender('8d4cce5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/preview/canvasPanelPreview.vue"
export default component.exports